(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkp-room-size-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mkp-room-size-guide')) {
    customElements.define('mkp-room-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.artwork = this.querySelector('[data-guide-artwork]');
        this.furniture = this.querySelector('[data-guide-furniture]');
        this.width = this.querySelector('[data-guide-width]');
        this.unit = this.querySelector('[data-guide-unit]');
        this.inches = 96;
        this.width.addEventListener('input', () => {
          this.inches = Number(this.width.value) / (this.unit.value === 'cm' ? 2.54 : 1);
          this.update();
        });
        this.unit.addEventListener('change', () => { this.showWidth(); this.update(); });
        this.artwork.addEventListener('change', () => this.update());
        this.furniture.addEventListener('change', () => { this.inches = Number(this.furniture.selectedOptions[0].dataset.width); this.showWidth(); this.update(); });
        this.querySelectorAll('[data-guide-enlarge]').forEach(button => button.addEventListener('click', () => {
          const target = this.querySelector('[data-guide-expanded]');
          const figure = button.closest('figure');
          target.replaceChildren(figure.querySelector('svg').cloneNode(true), figure.querySelector('figcaption').cloneNode(true));
          this.querySelector('[data-guide-dialog]').showModal();
        }));
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.querySelector('[data-guide-dialog]').close());
        this.update();
      }
      showWidth() {
        const factor = this.unit.value === 'cm' ? 2.54 : 1;
        this.width.min = 12 * factor;
        this.width.max = 240 * factor;
        this.width.value = this.inches > 0 ? Number((this.inches * factor).toFixed(4)) : '';
      }
      update() {
        const width = this.inches;
        const valid = Number.isFinite(width) && width >= 12 && width <= 240 && this.width.value !== '';
        this.width.setAttribute('aria-invalid', String(!valid));
        this.querySelector('[data-guide-error]').hidden = valid;
        this.querySelector('.mkp-size-guide__scenes').hidden = !valid;
        if (!valid) { this.querySelector('[data-guide-status]').textContent = ''; return; }
        const option = this.artwork.selectedOptions[0];
        if (!option) return;
        const room = this.furniture.selectedOptions[0].dataset;
        const scale = Number(room.pixels) / width;
        const center = Number(room.center), bottom = Number(room.bottom);
        const scenes = [...this.querySelectorAll('[data-guide-scene]')];
        const largestWidth = Math.max(...scenes.map(scene => Number(scene.dataset.outerWidth))) * scale;
        const largestHeight = Math.max(...scenes.map(scene => Number(scene.dataset.outerHeight))) * scale;
        const top = Math.min(0, bottom - largestHeight - 24);
        const viewHeight = Math.max(1024 - top, (largestWidth + 48) / 1.5);
        const viewWidth = viewHeight * 1.5;
        for (const scene of scenes) {
          scene.querySelector('svg').setAttribute('viewBox', `${768 - viewWidth / 2} ${top} ${viewWidth} ${viewHeight}`);
          const ow = Number(scene.dataset.outerWidth) * scale, oh = Number(scene.dataset.outerHeight) * scale;
          const pw = Number(scene.dataset.printWidth) * scale, ph = Number(scene.dataset.printHeight) * scale, face = Number(scene.dataset.frameFace) * scale;
          const overflow = center - ow / 2 < 16 || center + ow / 2 > 1520 || bottom - oh < 16;
          scene.querySelector('[data-guide-frame]').style.display = '';
          scene.querySelector('[data-guide-overflow]').hidden = !overflow;
          scene.querySelector('[data-guide-enlarge]').disabled = false;
          const setRect = (selector, left, top, w, h) => {
            const el = scene.querySelector(selector);
            for (const [key, value] of Object.entries({x:left,y:top,width:w,height:h})) el.setAttribute(key,value);
          };
          setRect('[data-guide-outer]', center-ow/2, bottom-oh, ow, oh);
          setRect('[data-guide-mat]', center-ow/2+face, bottom-oh+face, ow-face*2, oh-face*2);
          setRect('[data-guide-photo]', center-pw/2, bottom-oh+(oh-ph)/2, pw, ph);
          scene.querySelector('[data-guide-photo]').setAttribute('href',option.dataset.image);
          scene.querySelector('[data-guide-room]').setAttribute('href',room.room);
        }
        this.querySelector('[data-guide-product]').href = option.value;
        const help = new URL('/pages/get-help-choosing',location.origin);
        help.searchParams.set('artwork',option.dataset.title);
        help.searchParams.set('product',option.value);
        this.querySelector('[data-guide-help]').href = help.pathname+help.search;
        this.querySelector('[data-guide-status]').textContent = `${option.dataset.title} · ${this.furniture.selectedOptions[0].textContent} · ${this.width.value} ${this.unit.selectedOptions[0].textContent}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
